/**
 * Verwaltet die Logik der Loginseite, einschließlich der Auswahl des Bundeslandes und des Accounttyps.
 */
export default class Loginseite {
    private static _instance: Loginseite;

    public static getInstance() {
        return this._instance || (this._instance = new this());
    }

    private constructor() {
        localStorage.clear(); // Löscht alle Daten im lokalen Speicher beim Laden der Seite

        const weiche = document.querySelector(`html[data-projekt]`)?.getAttribute('data-projekt') ?? null;
        if (weiche !== 'vera5') {
            // @ts-ignore
            const bundeslandInput = new TomSelect(`#bundesland-input`, {
                create: false,
                allowEmptyOption: true,
                controlInput: null,
                searchField: [],
                onChange: (land: string) => this.onBundeslandChange(land),
                render: {
                    option: (data: any) => {
                        return `<div>${(data.src !== undefined) ? `<img class="wappen" src="${data.src}"/>` : ``}${data.text}</div>`;
                    },
                    item: (item: any) => {
                        return `<div>${(item.src !== undefined) ? `<img class="wappen" src="${item.src}"/>` : ``}${item.text}</div>`;
                    }
                }
            });

            // @ts-ignore
            new TomSelect(`#accounttyp-input`, {
                create: false,
                allowEmptyOption: true,
                controlInput: null,
                searchField: []
            });

            this.onBundeslandChange(bundeslandInput.getValue() as string);
        } else {
            document.querySelector(`#user-input`).removeAttribute('disabled');
            document.querySelector(`#passwort-input`).removeAttribute('disabled');
            document.querySelector(`div#login-form button[type='submit']`).removeAttribute('disabled');
        }

        // Loginseite erst einblenden, wenn die Seite vollständige geladen wurde
        document.querySelector(`body#login-page`)?.classList.add('active');
    }

    /**
     * Behandelt Änderungen in der Auswahl des Bundeslandes.
     * Aktiviert oder deaktiviert Eingabefelder und den Absende-Button basierend auf der Auswahl.
     * Passt die verfügbaren Accounttypen für spezifische Bundesländer an.
     * @param land Das ausgewählte Bundesland (z.B. 'ni', 'nw' oder '-').
     */
    private onBundeslandChange(land: string) {
        // Aktiviert oder deaktiviert die Login-Eingabefelder und den Submit-Button
        if (land !== '-') {
            document.querySelector(`div#login-form div.accounttyp`)?.classList.add('hidden');
            document.querySelector(`#user-input`).removeAttribute('disabled');
            document.querySelector(`#passwort-input`).removeAttribute('disabled');
            document.querySelector(`div#login-form button[type='submit']`).removeAttribute('disabled');
        } else {
            document.querySelector(`#user-input`).setAttribute('disabled', 'disabled');
            document.querySelector(`#passwort-input`).setAttribute('disabled', 'disabled');
            document.querySelector(`div#login-form button[type='submit']`).setAttribute('disabled', 'disabled');
        }

        // @ts-ignore
        let accounttypInput = (document.querySelector(`#accounttyp-input`) as unknown as TomSelect);
        // Zeigt länderspezifische Accounttypen für Niedersachsen (ni) und Nordrhein-Westfalen (nw) an
        if (['ni', 'nw'].includes(land)) {
            accounttypInput.tomselect.enable(); // Aktiviert das Accounttyp-Dropdown
            accounttypInput.tomselect.clearOptions(); // Entfernt vorherige Optionen
            if (land === 'ni')
                accounttypInput.tomselect.addOption(
                    [
                        {value: "koord", text: "Koordinatorenzugang"},
                        {value: "lg", text: "Lerngruppenzugang"}
                    ]
                )
            if (land === 'nw')
                accounttypInput.tomselect.addOption(
                    [
                        {value: "koord", text: "Koordinatorenzugang"},
                        {value: "standard", text: "Standardzugang"},
                        {value: "lg", text: "Lerngruppe (Französisch 9. Kl.)"}
                    ]
                )
            document.querySelector(`div#login-form div.accounttyp`)?.classList.remove('hidden'); // Zeigt den Accounttyp-Container an
        } else {
            accounttypInput.querySelector(`div#login-form div.accounttyp`)?.classList.add('hidden'); // Versteckt den Accounttyp-Container
            accounttypInput.tomselect.clearOptions(); // Entfernt alle Optionen
            accounttypInput.tomselect.disable(); // Deaktiviert das Accounttyp-Dropdown
        }
    }
}